import { render } from "./ListByActorView.vue?vue&type=template&id=1149e0d8"
import script from "./ListByActorView.vue?vue&type=script&lang=js"
export * from "./ListByActorView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__